const workCardsArr = document.querySelectorAll(
  '.second-work-card.if-not-search-page'
);
if (workCardsArr.length > 0) {
  workCardsArr.forEach((card) => {
    const image = card.querySelector('.second-work-card__image img');
    const galleryWrapper = card.querySelector('.second-work-card__gallery');

    if (galleryWrapper) {
      const galleryImages = card.querySelectorAll(
        '.second-work-card__gallery-img'
      );
      if (!galleryImages.length) return;

      const sources = [];
      const imgs = [];
      imgs.push(image);

      galleryImages.forEach((picture) => {
        const source = picture.querySelector('source');
        const img = picture.querySelector('img');

        if (source?.dataset.srcset) {
          source.srcset = source.dataset.srcset;
          delete source.dataset.srcset;
        }

        if (img?.dataset.src) {
          img.src = img.dataset.src;
          delete img.dataset.src;
        }

        sources.push(source);
        imgs.push(img);
      });

      let hoverTimeout;
      let cycleInterval;

      card.addEventListener('mouseenter', () => {
        if (imgs.length <= 1) return;

        clearTimeout(hoverTimeout);
        clearInterval(cycleInterval);

        const delay = card.dataset.hasHoveredBefore ? 300 : 500;

        hoverTimeout = setTimeout(() => {
          let currentIndex = 0;

          const showImage = (index) => {
            imgs.forEach((img, i) => {
              img.style.opacity = i === index ? '1' : '0';
            });
          };

          showImage(currentIndex);

          cycleInterval = setInterval(() => {
            currentIndex = (currentIndex + 1) % imgs.length;
            showImage(currentIndex);
          }, 2000);

          card.dataset.hasHoveredBefore = 'true';
        }, delay);
      });

      card.addEventListener('mouseleave', () => {
        clearTimeout(hoverTimeout);
        clearInterval(cycleInterval);

        imgs.forEach((img, i) => {
          img.style.opacity = i === 0 ? '1' : '0';
        });
      });
    }
  });
}
